import { AwsRum, type AwsRumConfig } from "aws-rum-web";
import { LOGIN_ENABLED } from "../common/loginAvailability";

let rum: AwsRum | undefined;

export const initCloudWatchRum = () => {
  /*
    * Initializes AWS CloudWatch RUM (Real User Monitoring) for the app.
    *
    * What it does:
    * - Connects the frontend to AWS CloudWatch RUM.
    *
    * How it works:
    * - Creates an AwsRum instance using environment variables:
    *     • App Monitor ID → Identifies which RUM monitor in AWS will receive the data.
    *     • App Version → Helps track errors and performance per application release.
    *     • AWS Region → AWS region to send data.
    *     • Identity Pool ID → Allows the browser to authenticate with AWS.
    *     • RUM Endpoint → Regional ingestion URL where browser telemetry is sent.
    *
    * How to use:
    * - Call this once when the app starts (called in index.js).
    * - Use getRum() later to log custom events or add user details.
    *
    * Why important:
    * - Without calling this function, no frontend monitoring data is sent to AWS.
  */
  if (process.env.REACT_APP_STORAGE_ENVIRONMENT !== "cloud_db" || !LOGIN_ENABLED) {
    // Skipped outside cloud_db, and while login is disabled (AWS exit: RUM is an AWS service).
    return;
  }
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: process.env.REACT_APP_AWS_RUM_IDENTITY_POOL_ID!,
      endpoint: process.env.REACT_APP_AWS_RUM_ENDPOINT!,
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: false,
      signing: true,
    };

    rum = new AwsRum(
      process.env.REACT_APP_AWS_RUM_APP_ID!,
      process.env.REACT_APP_AWS_RUM_VERSION!,
      process.env.REACT_APP_AWS_RUM_REGION!,
      config
    );
  } catch (error) {
    console.error("RUM initialization error", error);
  }
};

export const getRum = () => rum;
